<template>
    <!-- 等级说明 -->
    <div class='rankShow'>
        <div class="rank-title f-r a-c">{{ title }}</div>
        <div class="rank-tips f-r a-c" v-for="(item, index) in tipsList" :key="index">
            {{ item.label }}
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components: {},
    props: {
        title: String,
        tipsList: {
            type: Array,
            default: [
                // { label: '资金投入充足、合理，与企业远景发展、战略规划需求的符台性高；' },
                // { label: '形成兼具互联网信息化与业务流程管理职能的创新组织形态，成为企业流程变革和模式转型的主要推动者;' },
                // { label: '互联网化和信息化战略成为企业战路的重要组成部分，在企业各项业务规划中得到充分落实。' },
            ]
        }
    },
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    created() { },
    mounted() { },
    methods: {}
};
</script>
<style lang="less" scoped>
.rankShow {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;

    .rank-title,
    .rank-tips {
        height: 50px;
        border: 1px solid #efefef;
        padding-left: 15px;
    }
    .rank-title{
        font-weight: 600;
    }
    .rank-tips {
        position: relative;

        &::before {
            position: absolute;
            content: '';
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #2d50a1;
            top: 50%;
            transform: translateY(-50%);
            left: 5px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/rankShow.vue